import axios from "axios";
import { getAccessToken } from "./token";

export const apiUrl =
  typeof process !== 'undefined' && process.env.NODE_ENV === "development"
    ? "http://127.0.0.1:3000/v1/admin"
    : "https://api.application.fit/v1/admin";

export const axiosInstance = axios.create({
  baseURL: apiUrl,
  timeout: 60000,
  headers: { Accept: "application/json" },
});

axiosInstance.interceptors.request.use((config) => {
  const accessToken = getAccessToken();
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  return config;
});

// Response interceptor for handling 401 errors and token refresh
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Skip refresh for login and refresh-tokens endpoints to avoid infinite loops
    if (originalRequest.url?.includes('/auth/login') || originalRequest.url?.includes('/auth/refresh-tokens')) {
      return Promise.reject(error);
    }

    // If error is 401 and we haven't already tried to refresh
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const authData = localStorage.getItem('auth');
        if (authData) {
          const auth = JSON.parse(authData);
          const refreshToken = auth.tokens?.refresh?.token;

          if (refreshToken) {
            // Create a new axios instance without interceptors for refresh request
            const refreshAxios = axios.create({
              baseURL: apiUrl,
              timeout: 60000,
            });

            // Try to refresh the token
            const response = await refreshAxios.post('/auth/refresh-tokens', {
              refreshToken,
            });

            // Update tokens in localStorage
            auth.tokens = response.data;
            localStorage.setItem('auth', JSON.stringify(auth));

            // Retry the original request with new token
            originalRequest.headers.Authorization = `Bearer ${response.data.access.token}`;
            return axiosInstance(originalRequest);
          }
        }
      } catch (refreshError) {
        // Refresh failed, redirect to login
        localStorage.removeItem('auth');
        if (window.location.pathname !== '/admin/login') {
          window.location.href = '/admin/login';
        }
        return Promise.reject(refreshError);
      }
    }

    // If refresh failed or no refresh token, redirect to login
    if (error.response?.status === 401) {
      localStorage.removeItem('auth');
      if (window.location.pathname !== '/admin/login') {
        window.location.href = '/admin/login';
      }
    }

    return Promise.reject(error);
  }
);














